import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto } from 'src/app/core/api/models';
import {
  AccountService,
  AuthenticatedMobileService,
  ExcelService,
  GroupPriceDetailsService,
  GroupPricesService,
  OrganizationTransactionsService,
  ResellersService,
} from 'src/app/core/api/services';
import { AuthService } from 'src/app/core/services/authentication/auth.service';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { PaginatedListOfResellerOrganizationWithPaginationDto } from '../../../core/api/models/paginated-list-of-reseller-organization-with-pagination-dto';
import { ResellerOrganizationWithPaginationDto } from '../../../core/api/models/reseller-organization-with-pagination-dto';
import { OrganizationsService } from '../../../core/api/services/organizations.service';
import { OrganizationsComponent } from '../organizations/organizations.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserDocumentationFormModule } from '../users/user-documentation-form/user-documentation-form.module';
import { OrganizationTransactionsFormComponent } from '../organization-transactions/organization-transactions-form/organization-transactions-form.component';
import { OrganizationsFormComponent } from '../organizations/organizations-form/organizations-form.component';
import { OrganizationsAuthenticationFormComponent } from '../organizations/organizations-authentication-form/organizations-authentication-form.component';
import { organizationsResellersComponent } from '../organizations/organizations-resellers/organizations-resellers.component';
import { OrganizationDocumentationComponent } from '../organizations/organization-documentation/organization-documentation.component';
import { OrganizationGroupPriceDetailComponent } from '../organizations/organization-group-price-detail/organization-group-price-detail.component';


@Component({
    selector: 'app-reseller-organization',
    imports: [
        BaseIndexModule,
        FormsModule,
        ReactiveFormsModule,
        UserDocumentationFormModule,
        OrganizationTransactionsFormComponent,
        OrganizationsFormComponent,
        OrganizationsAuthenticationFormComponent,
        organizationsResellersComponent,
        OrganizationDocumentationComponent,
        OrganizationGroupPriceDetailComponent,
    ],
    templateUrl: './reseller-organization.component.html',
    styles: [``]
})
export class ResellerOrganizationComponent
  extends OrganizationsComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.resellerOrganization;
  protected currentService = inject(OrganizationsService);
  modelWithPagination$: Observable<PaginatedListOfResellerOrganizationWithPaginationDto>;
  items$: Observable<Array<ResellerOrganizationWithPaginationDto>>;
  fontSize: AppFontSize = 'sm';

  //#endregion

  constructor(
    protected groupPriceDetailService: GroupPriceDetailsService,
    protected groupPricesService: GroupPricesService,
    protected resellersService: ResellersService,
    protected authService: AuthService,
    public authenticatedMobileService: AuthenticatedMobileService,
    protected accountService: AccountService,
    protected OrganizationTransactionsService: OrganizationTransactionsService,
    protected excelFileService: ExcelService
  ) {
    super(
      groupPriceDetailService,
      groupPricesService,
      resellersService,
      authService,
      authenticatedMobileService,
      accountService,
      OrganizationTransactionsService,
      excelFileService
    );
  }
  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      switch (key) {
        case QueryStringTypesEnum.Resellers_key:
          this.onShowChildPage({
            values: [...(value as string)?.split('_')],
            setUrl: false,
            queryStringKey: key,
            class: this,
            showPagePropKey:
              this.componentProperties.isShowOrganizationTransactions,
            selectedPropKey: [
              {
                keyName: this.componentProperties.selectedOrganizationId,
                keyType: typeof this.selectedOrganizationId,
              },
            ],
          });
          break;
      }
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true, wrap: true },
      {
        title: `${this.tableVocabs}domainName`,
        name: 'domainName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.parentName,
        name: 'parentName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.credit,
        name: 'credit',
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}panelPrice`,
        name: 'panelPrice',
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isActiveSend`,
        name: 'isActiveSend',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isActive`,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isRealPerson`,
        name: 'isRealPerson',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isAuthenticated`,
        name: 'isAuthenticated',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isPostpaid`,
        name: 'isPostpaid',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}groupPriceCategoryTitle`,
        name: 'groupPriceCategoryTitle',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}groupPriceTitle`,
        name: 'groupPriceTitle',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region Api

  onHideOrganizationGroupPriceDetail() {
    this.showParent = true;
    this.getParentQueryString();
    this.isShowOrganizationGroupPriceDetail = false;
  }

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto> {
    if (window.location.search.includes('key-')) {
      this.paginationModel.pageNumber = 1;
      this.paginationModel.pageSize = 30;
      this.comparisonObjects = [];
      this.sortObject = [];
      this.setDefaultTableSort();
    }

    return this.currentService.organizationsGetResellerOrganizationWithPagination(
      { body: this.getBaseModelWithPaginationParams() }
    );
  }

  onUpdate(id?, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Update_key +
          '=' +
          id
      );
    }
    this.pageVocabs = 'pages.organizations.form.';
    this.formPageConfig.vocabs = this.pageVocabs;
    this.formPageConfig.editData = {};
    this.formPageConfig.isEditMode = true;
    this.baseGetByIdApi(id);
  }

  onCreate(type?: any, isFormModal?: boolean) {
    this.pageVocabs = 'pages.organizations.form.';
    this.formPageConfig.vocabs = this.pageVocabs;
    super.onCreate();
  }
}
